// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaRegClock } from "react-icons/fa";
// import { getAccessToken } from "../../storage/storage";

// const InvitationStatus = () => {
//   const dummyData = [
//     {
//       status: "Email Send",
//       date: "25/01/2025",
//       details: "Invitation Email sent to johndoe@gmail.com",
//       icon: <FaRegClock />,
//     },
//     {
//       status: "Email Delieverd",
//       date: "27/01/2025",
//       details: "Email delieverd to Recipeint",
//       icon: <FaRegClock />,
//     },
//     // {
//     //   status: "Invitation Accepted",
//     //   date: "28/01/2025",
//     //   details: "Receipient accpeted the invitation",
//     //   icon: (
//     //     <div class="border-2 border-green-500 rounded-full  inline-flex items-center justify-center">
//     //       <svg
//     //         xmlns="http://www.w3.org/2000/svg"
//     //         fill="none"
//     //         viewBox="0 0 24 24"
//     //         stroke-width="2"
//     //         stroke="green"
//     //         class="w-4 h-4"
//     //       >
//     //         <path
//     //           stroke-linecap="round"
//     //           stroke-linejoin="round"
//     //           d="M5 13l4 4L19 7"
//     //         />
//     //       </svg>
//     //     </div>
//     //   ),
//     // },
//   ];

//   const token = getAccessToken();
//   const BASE_URL = process.env.REACT_APP_BASE_URL;
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const id = sessionStorage.getItem("invitation_id");

//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/api/invitations/status/${id}/`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         // Convert object to array for mapping
//         setData([response.data]);
//       })
//       .catch((error) => {
//         console.error("Error fetching options:", error);
//       });
//   }, []);

//   const mergedData = [...dummyData, ...(data || [])];

//   return (
//     <div className="md:p-20 p-5 h-[100vh]">
//       <h1 className="text-3xl font-bold text-[#586989] mb-6">
//         Invitation Status
//       </h1>
//       <div className="flex justify-start ">
//         <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-x-auto w-full md:max-w-4xl">
//           <table className="w-full min-w-[600px]">
//             {/* Table Head */}
//             <thead className="bg-[#FFF5CE] text-[#586989] font-medium text-[14px] md:text-[16px]">
//               <tr>
//                 <th className="py-3 px-4 text-left">Status</th>
//                 <th className="py-3 px-4 text-left">Date & Time</th>
//                 <th className="py-3 px-4 text-left">Details</th>
//               </tr>
//             </thead>

//             {/* Table Body */}
//             <tbody>
//               {mergedData?.map((row, index) => (
//                 <tr
//                   key={index}
//                   className="bg-white text-[#1B1E27] border-t border-t-[#DFDFDF] text-left text-[12px] md:text-[14px]"
//                 >
//                   <td className="px-4 py-3 flex gap-3 items-center">
//                     <p className="text-[20px] text-[#586989]">
//                       {row.status === "Invitation Accepted" ? (
//                         <div className="border-2 border-green-500 rounded-full inline-flex items-center justify-center">
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             strokeWidth="2"
//                             stroke="green"
//                             className="w-4 h-4"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               d="M5 13l4 4L19 7"
//                             />
//                           </svg>
//                         </div>
//                       ) : (
//                         <FaRegClock />
//                       )}
//                     </p>
//                     {row.status}
//                   </td>
//                   <td className="px-4 py-3">
//                     {new Date(row.sent_at).toLocaleDateString()}{" "}
//                   </td>
//                   <td className="px-4 py-3">
//                     Invitation sent on {new Date(row.sent_at).toLocaleString()}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default InvitationStatus;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaRegClock } from "react-icons/fa";
import { getAccessToken } from "../../storage/storage";

const InvitationStatus = () => {
  const dummyData = [
    {
      status: "Email Send",
      sent_at: new Date(), // Current date
      details: "Invitation Email sent",
      icon: <FaRegClock />,
    },
    {
      status: "Email Delivered",
      sent_at: new Date(), // Current date
      details: "Invitation Email delivered",
      icon: <FaRegClock />,
    },
  ];

  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const id = sessionStorage.getItem("invitation_id");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/invitations/status/${id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data && response.data.sent_at) {
          setData([
            {
              ...response.data,
              sent_at: new Date(response.data.sent_at), // Convert to date object
            },
          ]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  // Merging API data with dummy data
  const mergedData = [...dummyData, ...data];

  // Sorting Data (Latest Date First)
  mergedData.sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));

  return (
    <div className="md:p-20 p-5 h-[100vh]">
      <h1 className="text-3xl font-bold text-[#586989] mb-6">
        Invitation Status
      </h1>
      <div className="flex justify-start">
        <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-x-auto w-full md:max-w-4xl">
          <table className="w-full min-w-[600px]">
            {/* Table Head */}
            <thead className="bg-[#FFF5CE] text-[#586989] font-medium text-[14px] md:text-[16px]">
              <tr>
                <th className="py-3 px-4 text-left">Status</th>
                <th className="py-3 px-4 text-left">Date & Time</th>
                <th className="py-3 px-4 text-left">Details</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {mergedData?.map((row, index) => (
                <tr
                  key={index}
                  className="bg-white text-[#1B1E27] border-t border-t-[#DFDFDF] text-left text-[12px] md:text-[14px]"
                >
                  <td className="px-4 py-3 flex gap-3 items-center">
                    <p className="text-[20px] text-[#586989]">
                      {row.status === "Invitation Accepted" ? (
                        <div className="border-2 border-green-500 rounded-full inline-flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="green"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </div>
                      ) : (
                        <FaRegClock />
                      )}
                    </p>
                    {row.status}
                  </td>
                  <td className="px-4 py-3">
                    {row.sent_at
                      ? new Date(row.sent_at).toLocaleDateString()
                      : "N/A"}
                  </td>
                  <td className="px-4 py-3">{row.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InvitationStatus;
